import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { OrganismsComponent } from './partners/organisms/organisms.component';
import { AddOrganismComponent } from './partners/organisms/add-organism/add-organism.component';
import { UserComponent } from './user/user.component';
import { CurrencyComponent } from './masters/currency/currency.component';
import { CountryComponent } from './masters/country/country.component';
import { LegalFormComponent } from './masters/legal-form/legal-form.component';
import { AddUserComponent } from './user/add-user/add-user.component';
import { AddDepartmentComponent } from './masters/add-department/add-department.component';
import { AddAddressComponent } from './masters/add-address/add-address.component';
import { AddContactComponent } from './masters/add-contact/add-contact.component';
import { AddCountryComponent } from './masters/country/add-country/add-country.component';
import { SubprofileComponent } from './subprofile/subprofile.component';
import { AddSubprofileComponent } from './subprofile/add-subprofile/add-subprofile.component';
import { HospitalsComponent } from './partners/hospitals/hospitals.component';
import { AddHospitalComponent } from './partners/hospitals/add-hospital/add-hospital.component';
import { PractitionersComponent } from './partners/practitioners/practitioners.component';
import { AddPractitionerComponent } from './partners/practitioners/add-practitioner/add-practitioner.component';
import { FinancialsComponent } from './partners/financials/financials.component';
import { AddFinancialComponent } from './partners/financials/add-financial/add-financial.component';
import { TelemedicinesComponent } from './partners/telemedicines/telemedicines.component';
import { AddTelemedicineComponent } from './partners/telemedicines/add-telemedicine/add-telemedicine.component';
import { LogisticsComponent } from './partners/logistics/logistics.component';
import { AddLogsticsComponent } from './partners/logistics/add-logistics/add-logistics.component';
import { PharmacyComponent } from './partners/pharmacy/pharmacy.component';
import { AddPharmacyComponent } from './partners/pharmacy/add-pharmacy/add-pharmacy.component';
import { InsuranceComponent } from './partners/insurance/insurance.component';
import { AddInsuranceComponent } from './partners/insurance/add-insurance/add-insurance.component';
import { AdministrationComponent } from './partners/administration/administration.component';
import { AddAdministrationComponent } from './partners/administration/add-administration/add-administration.component';
import { CategoryComponent } from './masters/category/category.component';
import { CategoryTypeComponent } from './masters/category-type/category-type.component';
import { AreaLevelsComponent } from './masters/area-levels/area-levels.component';
import { ProfessionComponent } from './masters/profession/profession.component';
import { AddProfessionComponent } from './masters/profession/add-profession/add-profession.component';
import { AddCategoryComponent } from './masters/category/add-category/add-category.component';
import { SpecialityComponent } from './masters/speciality/speciality.component';
import { SubSpecialityComponent } from './masters/sub-speciality/sub-speciality.component';
import { AddSubSpecialityMasterComponent } from './masters/sub-speciality/add-sub-speciality/add-sub-speciality.component';
import { AddSpecialityMasterComponent } from './masters/speciality/add-speciality/add-speciality.component';
import { AddHyperSpecialityMasterComponent } from './masters/hyper-speciality/add-hyper-speciality/add-hyper-speciality.component';
import { HyperSpecialityComponent } from './masters/hyper-speciality/hyper-speciality.component';
import { AddCategoryTypeComponent } from './masters/category-type/add-category-type/add-category-type.component';
import { MenuPrivilegesComponent } from './menu-privileges/menu-privileges.component';
import { PatientsComponent } from './patients/patients.component';
import { AddPatientComponent } from './patients/add-patient/add-patient.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { MedicalFilesComponent } from './medical-files/medical-files.component';
import { AddMedicalFileComponent } from './medical-files/add-medical-file/add-medical-file.component';
import { MedicalCarePlanComponent } from './medical-file/medical-care-plan/medical-care-plan.component';
import { OrganismOrgChartComponent } from './chart/organism-org-chart/organism-org-chart.component';
import { AddMedicalCarePlanComponent } from './medical-file/medical-care-plan/add-medical-care-plan/add-medical-care-plan.component';
import { PatientResolver } from './patients/patient.resolver';
import { AskTransferComponent } from './medical-files/ask-transfer/ask-transfer.component';
import { AddTransferDetailComponent } from './medical-files/ask-transfer/add-transfer-detail/add-transfer-detail.component';
import { CaseReviewComponent } from './medical-files/case-review/case-review.component';
import { UpDatesComponent } from './medical-files/up-dates/up-dates.component';
import { AddHospitalizationComponent } from './medical-files/up-dates/add-hospitalization/add-hospitalization.component';
import { AdministrativeFileComponent } from './medical-files/administrative-file/administrative-file.component';
import { AddHospitalizationResolver } from './medical-files/up-dates/add-hospitalization/add-hospitalization.resolver';
import { LogisticFileComponent } from './medical-files/logistic-file/logistic-file.component';
import { EncloseFileComponent } from './medical-files/enclose-file/enclose-file.component';
import { MedicalFileMastersComponent } from './masters/medical-file-masters/medical-file-masters.component';
import { RcpComponent } from './rcp/rcp.component';
import { AddRcpComponent } from './rcp/add-rcp/add-rcp.component';
import { MyspacePractitionarComponent } from './myspace-practitionar/myspace-practitionar.component';
import { MyspaceHospitalComponent } from './myspace-hospital/myspace-hospital.component';
import { MyspaceDashboardComponent } from './myspace-dashboard/myspace-dashboard.component';
import { ChangePasswordComponent } from './change-password/change-password.component';




const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'organisms', component: OrganismsComponent },
  { path: 'addOrganism', component: AddOrganismComponent },
  { path: 'country', component: CountryComponent },
  { path: 'arealevel1', component: CountryComponent },
  { path: 'arealevel2', component: CountryComponent },
  { path: 'arealevel3', component: CountryComponent },
  { path: 'arealevel4', component: CountryComponent },
  { path: 'town', component: CountryComponent },
  { path: 'currency', component: CurrencyComponent },
  { path: 'legalform', component: LegalFormComponent },
  { path: 'user', component: UserComponent },
  { path: 'addUser', component: AddUserComponent },
  { path: 'addDept', component: AddDepartmentComponent },
  { path: 'addAddress', component: AddAddressComponent },
  { path: 'addContact', component: AddContactComponent },
  { path: 'addCountry', component: AddCountryComponent },
  { path: 'subProfile', component: SubprofileComponent },
  { path: 'addSubProfile', component: AddSubprofileComponent },
  { path: 'hospitals', component: HospitalsComponent },
  { path: 'addHospital', component: AddHospitalComponent },
  { path: 'practitioners', component: PractitionersComponent },
  { path: 'addPractitioner', component: AddPractitionerComponent },
  { path: 'financials', component: FinancialsComponent },
  { path: 'addFinancial', component: AddFinancialComponent },
  { path: 'telemedicines', component: TelemedicinesComponent },
  { path: 'addTelemedicine', component: AddTelemedicineComponent },
  { path: 'logistics', component: LogisticsComponent },
  { path: 'addLogistics', component: AddLogsticsComponent },
  { path: 'addTelemedicine', component: AddTelemedicineComponent },
  { path: 'pharmacy', component: PharmacyComponent },
  { path: 'addPharmacy', component: AddPharmacyComponent },
  { path: 'insurance', component: InsuranceComponent },
  { path: 'addInsurance', component: AddInsuranceComponent },
  { path: 'administration', component: AdministrationComponent },
  { path: 'addAdministration', component: AddAdministrationComponent },
  { path: 'specialities', component: CategoryComponent },
  { path: 'category', component: CategoryComponent },
  { path: 'addCategory', component: AddCategoryComponent },
  { path: 'categoryType', component: CategoryTypeComponent },
  { path: 'areaLevels', component: AreaLevelsComponent },
  { path: 'profession', component: ProfessionComponent },
  { path: 'addProfession', component: AddProfessionComponent },
  { path: 'speciality', component: SpecialityComponent },
  { path: 'addSpeciality', component: AddSpecialityMasterComponent },
  { path: 'subSpeciality', component: SubSpecialityComponent },
  { path: 'addSubSpeciality', component: AddSubSpecialityMasterComponent },
  { path: 'hyperSpeciality', component: HyperSpecialityComponent },
  { path: 'addHyperSpeciality', component: AddHyperSpecialityMasterComponent },
  { path: 'addCategoryType', component: AddCategoryTypeComponent },
  { path: 'menuPrivileges', component: MenuPrivilegesComponent },
  { path: 'filemaster', component: MedicalFileMastersComponent },
  {
    path: 'patients', component: PatientsComponent /* , resolve: {
      masterData: PatientResolver
   }, */
  },
  {path:'addPatient',component:AddPatientComponent},
  {path: 'appointment',  component:  AppointmentComponent},
  {path: 'medcareplan',  component:  MedicalCarePlanComponent},
  {path: 'addmedcareplan',  component:  AddMedicalCarePlanComponent},
  {path: 'orgchart',  component:  OrganismOrgChartComponent},
  {path: 'medicalFiles',  component:  MedicalFilesComponent},
  {path: 'addMedicalFiles',  component:  AddMedicalFileComponent},
  {path: 'transfer',  component:  AskTransferComponent},
  {path: 'addTransfer',  component:  AddTransferDetailComponent},
  {path: 'caseReview',  component:  CaseReviewComponent},
  {path: 'upDates',  component:  UpDatesComponent},
  {path: 'addHospitalization',  component:  AddHospitalizationComponent, resolve: {masterData: AddHospitalizationResolver}},
  {path: 'adminFile',  component:  AdministrativeFileComponent},
  {path: 'logisticFile',  component:  LogisticFileComponent},
  {path: 'rcp',  component:  RcpComponent},
  {path: 'addrcp',  component:  AddRcpComponent},
  {path: 'myspacepractionar',  component:  MyspacePractitionarComponent},
  {path: 'myspacehospital',  component:  MyspaceHospitalComponent},
  {path: 'myspace',  component:  MyspaceDashboardComponent},
  {path: 'changePassword',  component:  ChangePasswordComponent},
  

  
  
  
  
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [PatientResolver]
})
export class AppRoutingModule { }
